import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { LogOut, Lock, Loader2, Eye, EyeOff, KeyRound } from 'lucide-react';
import { logout, changePassword } from '../store/authSlice';
import { useT } from '../utils/translate';

// Parolni o'zgartirish — ixtiyoriy, profil sahifasidan (ChangePasswordPage'dan farqli —
// u faqat standart parol bilan birinchi kirishda MAJBURIY ko'rsatiladi va butun ilovani
// bloklaydi; bu yerda mijoz istalgan vaqtda o'zi xohlasa parolini yangilaydi).
function ChangePasswordCard() {
  const t = useT();
  const dispatch = useDispatch();
  const loading = useSelector((s) => s.auth.loading);
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const reset = () => { setOpen(false); setPassword(''); setConfirm(''); setShowPassword(false); };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.trim().length < 4) return toast.error(t('changePassword.tooShort'));
    if (password !== confirm) return toast.error(t('changePassword.mismatch'));
    dispatch(changePassword(password.trim())).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        toast.success(t('changePassword.success'));
        reset();
      } else {
        toast.error(res.payload || t('changePassword.error'));
      }
    });
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)}
        className="card-body card w-full flex items-center gap-3 text-left hover:bg-surface-50 transition-colors">
        <div className="w-9 h-9 rounded-xl bg-primary-50 flex items-center justify-center shrink-0">
          <KeyRound className="w-4.5 h-4.5 text-primary-600" />
        </div>
        <span className="text-sm font-medium text-ink">{t('profile.changePassword')}</span>
      </button>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="card-body card space-y-3.5">
      <p className="text-sm font-semibold text-ink">{t('profile.changePassword')}</p>
      <div>
        <label className="block text-xs font-medium text-ink-secondary mb-1.5">{t('changePassword.newPassword')}</label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-tertiary" />
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            required minLength={4}
            placeholder="••••••"
            className="input input-with-icon pr-10"
            autoComplete="new-password"
            autoFocus
          />
          <button type="button" onClick={() => setShowPassword(v => !v)} tabIndex={-1}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-tertiary hover:text-ink transition-colors">
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-ink-secondary mb-1.5">{t('changePassword.confirmPassword')}</label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-tertiary" />
          <input
            type={showPassword ? 'text' : 'password'}
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            required minLength={4}
            placeholder="••••••"
            className="input input-with-icon"
            autoComplete="new-password"
          />
        </div>
      </div>
      <div className="flex items-center gap-2 pt-1">
        <button type="button" onClick={reset} className="btn-secondary btn-md flex-1">{t('profile.cancel')}</button>
        <button type="submit" disabled={loading} className="btn-primary btn-md flex-1 flex items-center justify-center gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} {t('changePassword.submit')}
        </button>
      </div>
    </form>
  );
}

export default function ProfilePage() {
  const t = useT();
  const dispatch = useDispatch();
  const customer = useSelector((s) => s.auth.customer);
  return (
    <div className="p-4 space-y-3">
      <div className="card-body card">
        <p className="text-lg font-bold text-ink">{customer?.name}</p>
        <p className="text-sm text-ink-secondary mt-0.5">{customer?.phone}</p>
        <p className="text-xs text-ink-tertiary mt-2">{customer?.organization?.name}</p>
      </div>
      <ChangePasswordCard />
      <button onClick={() => dispatch(logout())} className="btn-secondary btn-md w-full flex items-center justify-center gap-2 text-red-600">
        <LogOut className="w-4 h-4" /> {t('home.logout')}
      </button>
    </div>
  );
}
